// E7-konforme Adoption-Übergabe (In-Memory-Modul).
//
// Modul-skopiertes `let pending` — KEIN Storage (localStorage/sessionStorage/
// Cookie sind auf der Gastfläche verboten, P13-Vertrag §7). Die Payload
// überlebt SPA-Navigation (Modul-Singleton bleibt im Speicher), aber bewusst
// NICHT Reload/Voll-Redirect (Web-OAuth) — dokumentierte Grenze (Vertrag §5).
//
// runPendingAdoption() wird nach jeder erfolgreichen Auth aufgerufen
// (LoginPage-Erfolgspfade + CompleteProfileGate nach P12-Token-Adoption) und
// wirft NIE — ein Adoptions-Fehler darf den Login niemals blockieren.

import { adoptDemo, pingFunnel } from './api';
import type { DemoAdoptionPayload, DemoAdoptionResult } from './api';
import { markTourPart1Skipped } from '../../tour/TourProvider';

let pending: DemoAdoptionPayload | null = null;

export function setPendingAdoption(p: DemoAdoptionPayload): void {
  pending = p;
}

export function hasPendingAdoption(): boolean {
  return pending !== null;
}

export function clearPendingAdoption(): void {
  pending = null;
}

/** Nach erfolgreicher Auth aufrufen. Adoptiert falls Payload da; nie werfen (blockiert Login nicht). */
export async function runPendingAdoption(): Promise<DemoAdoptionResult | null> {
  const p = pending;
  if (!p) return null;
  pending = null;
  try {
    const r = await adoptDemo(p);
    try {
      await pingFunnel(p.session_id, 'adopted');
    } catch {
      /* still */
    }
    // E5-Rehang (P14): show_onboarding_tour ist der Serverwunsch, die Tour auf
    // die adoptierte Kampagne zu haengen. Der Nutzer landet gleich in seiner
    // Probeszene (/chat/:id) — die Dashboard-Tour Part 1 ("oeffne dein erstes
    // Abenteuer") ist damit redundant und entfaellt. Part 2 ("der Rest der App")
    // bleibt und startet spaeter regulaer auf /dashboard, weil sein Gate
    // part1-done nun erfuellt sieht. Hier zentral gewirt (statt an jedem der 4
    // Auth-Erfolgspfade), die alle durch runPendingAdoption laufen.
    if (r?.show_onboarding_tour) {
      try { markTourPart1Skipped(); } catch { /* Tour-Rehang darf den Login nie stoeren */ }
    }
    return r;
  } catch {
    return null;
  }
}
